import { referencesDetailsSchema, referencesDetailsType } from "@/src/mocks";
import { reduceTypeToObj } from "@/src/utils/generic-utils";
import { FormProps } from "./form-one";
import BaseButton from "@/src/components/landing-page/button/base-button";
import { FloatingLabelInput } from "@/src/components";
import FormContainer, { FormSubSectionTitle } from "./form-container";

const referencesDetailsLabel = [
  "Reference name",
  "Reference occupation",
  "Reference phone no",
  "Reference address",
  "Reference name",
  "Reference occupation",
  "Reference phone no",
  "Reference address",
];

const referencesDetailsLabelMap = reduceTypeToObj<referencesDetailsType>(
  referencesDetailsLabel,
  referencesDetailsSchema.describe().fields
);

function FormThree({
  nextStep,
  trigger,
  getValues,
  register,
  errors,
}: FormProps) {
  const values = getValues();
  const dotNotLabel = Object.keys(
    referencesDetailsSchema.describe().fields
  ).map((el) => el);
  // async function onValidate(): Promise<void> {
  //   try {
  //     await referencesDetailsSchema.validate(values, { abortEarly: false });

  //     nextStep();
  //   } catch (error: any) {
  //     // @ts-ignore
  //     trigger(dotNotLabel);
  //     console.error(error.message);
  //   }
  // }

  return (
    <section>
      <FormContainer
        // title="We need details of your references"
        subTitle="Here are details of your reference"
      >
        <form>
          <div className="py-2">
            {/* <FormSubSectionTitle title="Details of reference" /> */}
            <div className="my-2">
              <p className="my-2  text-[#434249]">Reference 1</p>
              <div className="mb-5">
                <FloatingLabelInput
                  label={referencesDetailsLabelMap.reference1Name}
                  id="referencesDetails.reference1Name"
                  placeholder={referencesDetailsLabelMap.reference1Name}
                  {...register("reference1Name")}
                  error={errors?.reference1Name?.message}
                />
              </div>

              <div className="mb-5">
                <FloatingLabelInput
                  label={referencesDetailsLabelMap.reference1Occupation}
                  id="referencesDetails.ref1Occupation"
                  placeholder={referencesDetailsLabelMap.reference1Occupation}
                  {...register("reference1Occupation")}
                  error={errors?.reference1Occupation?.message}
                />
              </div>

              <div className="mb-5">
                <FloatingLabelInput
                  label={referencesDetailsLabelMap.reference1PhoneNumber}
                  id="referencesDetails.reference1PhoneNumber"
                  type="number"
                  placeholder={referencesDetailsLabelMap.reference1PhoneNumber}
                  {...register("reference1PhoneNumber")}
                  error={errors?.reference1PhoneNumber?.message}
                />
              </div>

              <div className="mb-5">
                <FloatingLabelInput
                  label={referencesDetailsLabelMap.reference1Address}
                  id="referencesDetails.ref1Address"
                  placeholder={referencesDetailsLabelMap.reference1Address}
                  {...register("reference1Address")}
                  error={errors?.reference1Address?.message}
                />
              </div>
            </div>
            <div className="my-6">
              <p className="my-2  text-[#434249]">Reference 2</p>
              <div className="mb-5">
                <FloatingLabelInput
                  label={referencesDetailsLabelMap.reference2Name}
                  id="referencesDetails.ref2Name"
                  placeholder={referencesDetailsLabelMap.reference2Name}
                  {...register("reference2Name")}
                  error={errors?.reference2Name?.message}
                />
              </div>

              <div className="mb-5">
                <FloatingLabelInput
                  label={referencesDetailsLabelMap.reference2Occupation}
                  id="referencesDetails.ref2Occupation"
                  placeholder={referencesDetailsLabelMap.reference2Occupation}
                  {...register("reference2Occupation")}
                  error={errors?.reference2Occupation?.message}
                />
              </div>

              <div className="mb-5">
                <FloatingLabelInput
                  label={referencesDetailsLabelMap.reference2PhoneNumber}
                  id="referencesDetails.ref2PhoneNumber"
                  type="number"
                  placeholder={referencesDetailsLabelMap.reference2PhoneNumber}
                  {...register("reference2PhoneNumber")}
                  error={errors?.reference2PhoneNumber?.message}
                />
              </div>

              <div className="mb-5">
                <FloatingLabelInput
                  label={referencesDetailsLabelMap.reference2Address}
                  id="referencesDetails.ref2Address"
                  placeholder={referencesDetailsLabelMap.reference2Address}
                  {...register("reference2Address")}
                  error={errors?.reference2Address?.message}
                />
              </div>
            </div>
          </div>
          {/* <div className="my-6">
            <BaseButton onClick={onValidate} fullWidth>
              Proceed
            </BaseButton>
          </div> */}
        </form>
      </FormContainer>
    </section>
  );
}

export default FormThree;
